import { createFileRoute } from "@tanstack/react-router";
import { AdminAssetTypeRulesSection } from "./fullRules";

export const Route = createFileRoute(
	"/_authenticated/(admin-app)/_admin/admin/configuration/assetTypes/$assetTypeId/rules",
)({
	component: AdminAssetTypeRulesTab,
});

function AdminAssetTypeRulesTab() {
	return (
		<div className="px-5 pb-5">
			<AdminAssetTypeRulesSection stayOnRoute />
		</div>
	);
}
